export default {
  "h1-title": "트레이딩 도구",
  imgUrlLang: "-en",
  "public-btn-text": "지금 바로 체험하기",
  screen0: {
    title: "거래 요구 사항을 충족하는 도구 라이브러리 생성",
  },
  screen1: {
    title: "동일한 그림의 제품 오버레이 도구",
    desc: "이 도구는 투자자에게 두 상품의 임의 주기 및 임의 K 라인의 상대적 강약을 명확하게 알 수 있게 하며, 돌파구의 유효성을 식별할 수 있게 합니다.",
  },
  screen2: {
    title: "MACD 전문 지표(이중선)",
    desc: "이 도구는 주식 및 선물에 일반적으로 사용되는 MACD 지표 도구입니다. MT4에 포함된 MACD에 비해 다양한 이점을 제공하여 거래자의 선호도 및 습관에 더욱 적합하게 합니다.",
  },
  screen3: {
    title: "MTDriver 손익 통계 지표",
    desc: "이 도구는 투자자가 다양한 기간 동안 손익을 정확히 파악하는 데 도움이 될 수 있습니다.",
  },
  screen4: {
    title: "가격 변동 모바일 푸시알림",
    desc: "대부분의 투자자는 시장을 볼 수 있는 시간이 한정되어 있기 때문에 가격 변동에 대한 모바일 푸시 알림 기능은 시장의 잡음을 피하면서 시장 동향을 파악하는 데 도움을 줄 수 있습니다.",
  },
  screen5: {
    title: "원클릭 마감 EA",
    desc: "운영 인터페이스는 차트 인터페이스에 위치하여 투자자가 극한의 시장 상황이 발생할 때 보다 빠르고 편리하게 손실을 막을 수 있습니다.",
  },
  screen6: {
    title: "EA 정시 매매",
    desc: "MQL4Experts 폴더에 넣고 지정된 시간에 매매하는 EA, 사용법은 매우 간단하니 직접 탐색해 보세요.",
  },
  screen7: {
    title: "순자산 모니터링 EA",
    desc: "MQL4Experts 폴더에 넣은 뒤 순자산 변화의 EA를 모니터링합니다. 그 후 Sounds에 프롬프트하려는 사운드 파일을 넣은 다음 EA의 음악 이름에 해당 음악 파일의 이름을 입력하세요.",
  },
  EA交易与指标: "EA 거래 및  지표",
  EBC独家精选的MT4:
    "EBC는 투자자의 거래 결정과 전략을 최적화하여 시장에서 우위를 점할 수 있도록 독점적인 MT4 및 MT5 지표와 EA(자동매매 프로그램) 거래 도구를 제공합니다.",
  EBCTurbo账户分析系统:
    "EBC 터보: 메타트레이더 지표를 활용해 거래를 분석하고 전략을 최적화합니다.",
  实用型技术指标集:
    "실용적인 지표: 시장의 트렌드를 파악하고 최선의 거래 기회를 잡을 수 있습니다. ",
  外汇EA策略执行器:
    "시장 변화에 능동적으로 대응하는 외환 EA 전략 실행기 — 항상 한발 앞선 의사결정을 지원합니다.",
  EBCTurbo账户分析系统2: "EBC 터보 계좌 분석 시스템",
  EBC独家盈亏统计和历史回溯工具:
    "EBC의 독점 손익 통계 및 히스토리 백테스트 도구는 다차원적인 평가 시스템과 내장 모델을 기반으로 거래 세부 사항을 종합적으로 분석하여 거래 전략을 최적화합니다.",
  净值收益曲线: "순수익률 그래프",
  收益率: "수익률",
  最大回撤: "최대 손실",
  标准差: "표준 편차",
  获利系数: "이익 계수",
  夏普比率: "샤프 비율",
  盈利交易: "거래 수익(승률)",
  六维评级图: "다차원 분석 차트",
  每日: "일일/월별 통계",
  获取EBCTurbo: "EBC 터보 사용하기",
  实用型技术指标集2: "실용적인  기술 지표 세트",
  经过优化的常用技术指标:
    "최적화된  기술 지표, 시장분석 및 사용자 지정 구을 지원하여 사용자가  시장 동향을 정확하게 판단할 수 있습니다.",
  同图商品叠加工具: "오버레이 차트 도구",
  帮助投资者通过叠加两个商品的走势:
    "지표 위에 겹쳐서 표시되는 오버레이 차트 지표는 두 개의 상품 간 낮은 저항선의 강도 및 주요 돌파 지점을 표시하여 거래 결정의 정확도를 높여줍니다.",
  MACD专业指标: "MACD Pro 지표 (확장형)",
  提供比普通MACD更为精准的双线指标:
    "MACD Pro 지표는 표준 버전보다 더 정밀한 확장형 MACD 지표를 제공하여 시장의 매수 및 매도 신호를 더 잘 파악하고 최선의 거래 기회를 잡을 수 있게 해줍니다.",
  MTDriver盈亏统计指标: "MTDriver 손익 통계 지표",
  该指标可协助投资者实时统计不同周期内的盈亏情况:
    "MTDriver는 실시간으로 여러주기의 이익과 손실을 계산하는데 도움이 되며  이를 통해 더 정확한 거래 전략을 세우는 데 필요하고 중요한 데이터를 지원합니다.",
  价格变动手机推送通知: "가격 변동 모바일 알림",
  实时监控市场价格波动:
    "실시간으로 시장 가격을 모니터링하고 큰 변화가 발생할 경우 즉시 모바일 발송 알림을 전송하여 중요한 순간 신속한 대응을 할 수 있도록 도와줍니다.",
  获取指标: "지표 받기",
  外汇EA策略执行器2: "외환 EA 전략 실행기",
  基于高级算法自动执行EA交易策略:
    "고급 알고리즘을 기반으로 EA 거래 전략을 자동 실행하며, 실시간으로 시장에 대응해 빠르고 안전한 거래를 구현합니다.",
  定时下单EA软件: "시간 지정 주문 EA 소프트웨어",
  通过MT4EA:
    "MT4/MT5 EA를 통해 사전에 설정한 시간에 자동으로 주문을 실행하며, 별도의 수동 개입 없이 전략을 수행합니다.정해진 시간에 정확하고 신속한 거래가 필요한 시간 기반 전략에 최적화된 솔루션입니다.",
  EA交易常见问题: "EA 거래 자주 묻는 질문",
  qaList: [
    {
      q: "1. EA 거래란 무엇이며, 어떻게 작동하나요?",
      a: [
        "EA(Expert Advisor) 거래는 MT4 또는 MT5 플랫폼에서 지능형 자동 거래 시스템을 이용해 거래를 자동으로 실행하는 방식을 말합니다.미리 설정된 전략에 따라 매수, 매도, 손절, 이익 실현 등을 자동으로 수행할 수 있어, 수동 개입 없이 자동화된 거래를 실현하며, 거래자의 실행 효율을 높이고, 모니터링 시간을 절감하며, 감정에 의한 판단 오류를 줄이는 데 도움이 됩니다.",
      ],
    },
    {
      q: "2. 서로 다른 거래 플랫폼의 EA 소프트웨어는 어떤 차이가 있나요?",
      a: [
        `MT4 EA는 MQL4 언어로 작성되어 MetaTrader 4 플랫폼에서만 실행되며,
MT5 EA는 MQL5 언어를 기반으로 MetaTrader 5 플랫폼에서 작동합니다.

MT5는 보다 다양한 기능을 지원하고, 다중 스레드 백테스트가 가능한 것이 특징입니다.
어떤 플랫폼을 선택할지는 거래 목적과 EA 소프트웨어의 호환성에 따라 달라지며,
두 플랫폼은 상호 호환되지 않습니다.`,
      ],
    },
    {
      q: "3. 하나의 플랫폼에서 여러 EA 소프트웨어를 동시에 실행할 수 있나요?",
      a: [
        `하나의 MetaTrader 플랫폼에서 여러 EA를 실행할 수는 있지만, 각 EA는 반드시 서로 다른 차트에 개별적으로 적용해야 합니다.
하나의 차트에는 한 개의 EA만 실행할 수 있으며,
EA 간 주문 충돌이나 시스템 자원 과다 사용과 같은 문제가 발생하지 않도록 주의해야 합니다.`,
      ],
    },
    {
      q: "4. 외환 EA는 여러 통화쌍을 동시에 거래할 수 있나요?",
      a: [
        `가능하지만, 이는 EA의 설계 방식에 따라 다릅니다.
일부 EA는 하나의 통화쌍만 지원하도록 제작된 반면, 보다 강력한 EA는 다중 종목 거래를 지원할 수 있습니다.
특히 MT5 기반 EA는 플랫폼 자체가 멀티스레딩을 지원하기 때문에, 여러 종목을 더 효과적으로 처리할 수 있습니다.`,
      ],
    },
    {
      q: "5. 나에게 맞는 외환 EA는 어떻게 선택하나요?",
      a: [
        `EA를 선택할 때는 본인의 거래 스타일(예: 추세 추종형, 스캘핑형), 자금 규모, 위험 선호도를 종합적으로 고려해야 합니다.
EA의 과거 백테스트 성과, 실거래 퍼포먼스, MT4 또는 MT5 호환 여부를 확인한 후,
실거래에 앞서 반드시 데모 계좌에서 안정성과 수익성을 테스트해보는 것이 중요합니다.`,
      ],
    },
    {
      q: "6. EA 거래는 수익을 보장하나요?",
      a: [
        `어떠한 거래 도구도 수익을 보장할 수는 없습니다.
EA의 수익성은 전략의 논리, 시장 환경, 그리고 위험 관리 설정에 따라 달라집니다.
MT4 EA든 MT5 EA든 모두 거래를 지원하는 도구일 뿐,
투자자는 시장 상황에 따라 성과를 지속적으로 모니터링하고 전략을 조정해야 합니다.`,
      ],
    },
  ],
  url: "https://ebcturbo.com/tools?language=en",
};
